<template>
  <div class="col-md-12 p-0 report-list-page">
    <PopupHistorySendMail
      v-on:exit="closeModal"
      :id_customreport="id_customreport"
      v-if="isEnablePopup == 'list-history-send'"
    />
    <PopupSendCustomer
      v-on:exit="closeModal"
      :data_customer="dataCustomer"
      v-on:applyData="sendEmailToCustomer"
      v-if="isEnablePopup == 'modal-send-customer'"
    />
    <section class="report-hero">
      <div class="report-hero__content">
        <span class="report-hero__eyebrow">MONTHLY OPERATIONAL REPORT</span>
        <h2>Generate Report</h2>
        <p>Kelola laporan bulanan, dokumentasi pekerjaan, dan pengiriman laporan kepada client.</p>
      </div>
      <div class="report-hero__summary">
        <i class="ti ti-files"></i>
        <div>
          <strong>{{ result_report_total }}</strong>
          <span>Total Report</span>
        </div>
      </div>
    </section>

    <div class="card report-list-card">
      <div class="card-body">
        <div class="table-header report-table-header">
          <h5 class="report-card__title">
            Daftar Laporan Bulanan <br />
            <small>Pilih periode dan status untuk menemukan laporan kontrak.</small>
          </h5>
          <div class="group-search report-actions pull-right">
            <a class="btn report-icon-btn" title="Cari laporan" @click="isActiveSearch()">
              <i :class="isEnableTools == false ? 'ti ti-search' : 'ti ti-close'"></i>
            </a>
            <div class="select" v-if="isEnableTools">
              <select v-model="meta_data.skey" @change="meta_data.sval = ''">
                <option value="">-- Choose Field --</option>
                <option value="contract_number">Contract Number</option>
                <option value="client_name">Client Name</option>
              </select>
            </div>
            <div class="group" v-if="isEnableTools">
              <input
                type="text"
                v-model="meta_data.sval"
                @keyup.enter="tableSearch()"
                placeholder="Enter Keyword ...."
              />
              <a class="btn report-search-btn" @click="tableSearch()">
                <i class="ti ti-search"></i> Search
              </a>
            </div>
            <router-link
              :to="{ name: 'report/generate-report/create' }"
              class="btn report-create-btn"
              v-if="$store.state.app.access.includes('insert')"
            >
              <i class="ti ti-plus"></i> Create New
            </router-link>
          </div>

          <div class="report-filter-panel">
            <div class="report-filter-field">
              <label>Periode Laporan</label>
              <date-picker
                v-model="selectedMonth"
                type="month"
                format="YYYY-MM"
                value-type="format"
                placeholder="Pilih Bulan"
                @change="onMonthChange"
              />
            </div>
            <div class="report-filter-field" v-if="isRoot">
              <label>Branch Station</label>
              <SelectBranch v-on:processBranch="processBranch" />
            </div>
            <div class="report-filter-field">
              <label>Status Report</label>
              <select class="form-control" v-model="status" @change="getDataReport()">
                <option value="all">-- All Status --</option>
                <option value="draft">Draft</option>
                <option value="revisi">Revisi</option>
                <option value="publish">Publish</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row p-4" v-if="$store.state.loading.status">
          <div class="col-md-6">
            <ListLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            ></ListLoader>
          </div>
          <div class="col-md-6">
            <ListLoader
              :speed="1"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
            ></ListLoader>
          </div>
        </div>
        <div v-else class="table-cover report-table-cover">
          <table class="table-hover">
            <thead>
              <tr>
                <th>Action</th>
                <th>Contract Number</th>
                <th>Client Information</th>
                <th>Contract Period</th>
                <th>Report Status</th>
                <th>Created By</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody v-if="result_report_total > 0 && result_report_data.length > 0">
              <tr v-for="(item, idx) in result_report_data" :key="idx">
                <td>
                  <div class="report-row-actions">
                    <a
                      href="javascript:;"
                      title="Send To Customer"
                      @click="OpenModalSendCustomer(item)"
                      class="report-action report-action--send"
                      v-if="$store.state.app.access.includes('update') && item.status == 'publish'"
                    >
                      <i class="ti ti-share"></i>
                    </a>
                    <a
                      href="javascript:;"
                      title="History Send Email"
                      @click="historySend(item.id)"
                      class="report-action report-action--history"
                      v-if="item.status == 'publish'"
                    >
                      <i class="ti ti-eye"></i>
                    </a>
                    <router-link
                      title="Detail Report Generate"
                      :to="{
                        name: 'report/generate-report/detail',
                        query: { report_id: item.id },
                      }"
                      class="report-action report-action--detail"
                      v-if="$store.state.app.access.includes('detail')"
                    >
                      <i class="ti ti-pencil-alt"></i>
                    </router-link>
                    <a
                      title="Hapus Report Generate"
                      href="javascript:;"
                      v-if="isRoot || $store.state.app.access.includes('update')"
                      @click="RemoveGenerateReport(item.id)"
                      class="report-action report-action--delete"
                    >
                      <i class="ti ti-trash"></i>
                    </a>
                  </div>
                </td>
                <td width="200">
                  <strong class="report-contract-number">{{ item.contract_number }}</strong>
                </td>
                <td class="pr-3" width="360">
                  <b class="report-client-name">{{ item.client_name }}</b>
                  <small class="report-client-address">{{ item.client_address }}</small>
                </td>
                <td width="210" class="pr-3">
                  <span class="report-contract-status">{{ item.contract_status }}</span>
                  <small class="report-period">
                    <i class="ti ti-calendar"></i>
                    {{ item.contract_start_date }} - {{ item.contract_end_date }}
                  </small>
                </td>
                <td width="150" class="pr-3">
                  <span
                    class="report-status"
                    :class="{
                      'report-status--draft': item.status == 'draft',
                      'report-status--publish': item.status == 'publish',
                      'report-status--revision': item.status == 'revisi',
                    }"
                  >
                    <i class="report-status__dot"></i>{{ item.status }}
                  </span>
                  <small v-if="item.status == 'revisi'" class="report-revision-note">
                    {{ item.note_revisi }}
                  </small>
                </td>
                <td class="pr-3">{{ item.user_name }}</td>
                <td class="pr-3">{{ item.created_at }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7">
                  <div class="report-empty-state">
                    <i class="ti ti-files"></i>
                    <strong>Data laporan tidak ditemukan</strong>
                    <span>Coba ubah periode, branch, status, atau kata pencarian.</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="!$store.state.loading.status" class="pagination report-pagination">
          <small class="info">
            <i class="ti ti-split-h"></i> Scroll horizontal to view data.
          </small>
          <paginate
            v-if="parseInt(result_report_last_page) > 1"
            :page-count="parseInt(result_report_last_page)"
            :page-range="3"
            :margin-pages="2"
            :force-page="currentPage"
            :click-handler="clickCallback"
            :container-class="'pagination'"
            :page-class="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixServerDate from "../../../mixin/mix_serverdate.js";
import { mapState } from "vuex";
import axios from "axios";
import SelectBranch from "../../Branch/@SelectBranch";
import { ContentLoader, ListLoader, CodeLoader } from "vue-content-loader";
import PopupHistorySendMail from "./@PopupHistorySendMail.vue";
import PopupSendCustomer from "./@PopupSendCustomer.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

export default {
  mixins: [MixServerDate],
  data() {
    return {
      isEnablePopup: false,
      id_customreport: null,
      dataCustomer: null,
      meta_url: "report/generate",
      isEnableTools: false,
      meta_data: {
        okey: "created_at",
        oval: "desc",
        skey: "",
        sval: "",
      },
      selectedMonth: this.getCurrentYearMonth(),
      result_report: null,
      result_report_data: [],
      result_report_total: 0,
      result_report_last_page: 0,
      branchId: "all",
      status: "all",
      isClient: false,
      isRoot: false,
      currentPage: 1,
    };
  },
  components: {
    ContentLoader,
    ListLoader,
    CodeLoader,
    PopupHistorySendMail,
    PopupSendCustomer,
    SelectBranch,
    DatePicker,
  },
  computed: {
    ...mapState("crud", {
      msg_error: (state) => state.error,
    }),
  },
  created() {
    const roleUserPrivilegesName = ["root", "hrd nasional"];

    if (
      !roleUserPrivilegesName.includes(
        localStorage.getItem("userPrivilegesName")
      )
    ) {
      this.isClient =
        localStorage.getItem("userIdPrivileges") == 14 ? true : false;
      this.branchId = localStorage.getItem("userBranchId");
    } else {
      this.isRoot = true;
    }

    this.getDataReport();
  },
  methods: {
    getCurrentYearMonth() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // pad with leading 0
      return `${year}-${month}`;
    },
    clickCallback: function (pageNum) {
      this.currentPage = Number(pageNum);
      // console.log("clickCallback", this.currentPage);
      this.getDataReport();
    },
    processBranch(idBranch) {
      this.branchId = idBranch;
      // console.log(this.branchId);
      this.getDataReport();
    },
    onMonthChange(val) {
      this.getDataReport();
    },
    async getDataReport() {
      // console.log(this.meta_data);
      this.result_report = null;

      console.log({
        filter: this.meta_data,
        branch_id: this.branchId,
        status: this.status,
        year_month: this.selectedMonth,
      });

      await axios
        .post(this.meta_url + "/list?page=" + this.currentPage, {
          filter: this.meta_data,
          branch_id: this.branchId,
          status: this.status,
          year_month: this.selectedMonth,
        })
        .then((res) => {
          // this.result_report = res.data;
          this.result_report_data = res.data.data;
          this.result_report_total = res.data.total;
          this.result_report_last_page = res.data.last_page;
        })
        .catch((error) => {
          console.log(error.statusText);
        });
    },
    async RemoveGenerateReport(id) {
      let text = "Apakah anda yakin !\nMenghapus data Report ini.";
      // console.log(this.meta_url);
      if (confirm(text) == true) {
        this.$store.state.loading.msg = "Loading ...";
        this.$store.state.loading.status = true;

        await axios
          .post(this.meta_url + "/delete", {
            id: id,
          })
          .then((res) => {
            let response = res.data;

            if (response.status) {
              this.getDataReport();
              this.$store.state.alert.status = true;
              this.$store.state.alert.type = "success";
              this.$store.state.alert.msg = response.message;
            } else {
              this.$store.state.alert.status = true;
              this.$store.state.alert.type = "trash";
              this.$store.state.alert.msg = response.message;
            }
          })
          .catch((error) => {
            console.log(error.statusText);
          })
          .finally(() => {
            setTimeout(() => {
              this.$store.state.loading.status = false;
            }, 1750);
          });
      }
      // console.log(id, text);
    },
    historySend(id) {
      this.id_customreport = id;
      this.isEnablePopup = "list-history-send";
    },
    closeModal() {
      this.isEnablePopup = false;
    },
    OpenModalSendCustomer(item) {
      this.dataCustomer = item;
      this.isEnablePopup = "modal-send-customer";
    },
    sendEmailToCustomer(data) {
      // console.log(data);
      if (data.file !== null) {
        this.SendReportToCustomerWithFile(data.id, data.email, data.file);
      } else {
        this.SendReportToCustomer(data.id);
      }
    },
    async SendReportToCustomerWithFile(id, email, file) {
      this.closeModal();
      this.$store.state.loading.msg = "Process send report ...";
      this.$store.state.loading.status = true;

      const formData = new FormData();
      formData.append("id", id);
      formData.append("email", email);
      formData.append("file", file);
      await axios
        .post(this.meta_url + "/send-to-customer-with-file", formData, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then((res) => {
          const response = res.data;
          // console.log(response);
          if (response.result == "ok") {
            this.$store.state.alert.status = true;
            this.$store.state.alert.type = "success";
            this.$store.state.alert.msg = response.msg;
          } else {
            this.$store.state.alert.status = true;
            this.$store.state.alert.type = "trash";
            this.$store.state.alert.msg = response.msg;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.alert.status = true;
          this.$store.state.alert.type = "trash";
          this.$store.state.alert.msg = "Failed Send mail to Customer ..";
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.state.loading.status = false;
          }, 1000);
        });
    },
    async SendReportToCustomer(id) {
      this.closeModal();
      let params = {
        id: id,
      };

      this.$store.state.loading.msg = "Process send report ...";
      this.$store.state.loading.status = true;

      await axios
        .post(this.meta_url + "/send-to-customer", params)
        .then((res) => {
          const response = res.data;
          if (response.result == "ok") {
            this.$store.state.alert.status = true;
            this.$store.state.alert.type = "success";
            this.$store.state.alert.msg = response.msg;
          } else {
            this.$store.state.alert.status = true;
            this.$store.state.alert.type = "trash";
            this.$store.state.alert.msg = response.msg;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.alert.status = true;
          this.$store.state.alert.type = "trash";
          this.$store.state.alert.msg = "Failed Send mail to Customer ..";
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.state.loading.status = false;
          }, 1000);
        });
    },
    isActiveSearch() {
      this.isEnableTools = !this.isEnableTools;
      if (this.isEnableTools) this.meta_data.sval = "";
    },

    tableSearch() {
      if (this.meta_data.skey == "") {
        alert("🙏, Please choose target field");
        return;
      }
      if (this.meta_data.sval == "") {
        alert("🙏, Please enter the keyword");
        return;
      }
      // this.tableQuery();
      this.getDataReport();
    },
  },
};
</script>
<style scoped>
.report-list-page {
  color: #344a58;
}

.report-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(45, 111, 145, 0.16);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 150px;
  overflow: hidden;
  padding: 25px 28px;
  position: relative;
}

.report-hero::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
  height: 210px;
  position: absolute;
  right: -55px;
  top: -95px;
  width: 210px;
}

.report-hero__content {
  max-width: 680px;
  position: relative;
  z-index: 1;
}

.report-hero__eyebrow {
  color: #c7f4eb;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.report-hero h2 {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  margin: 5px 0 6px;
}

.report-hero p {
  color: rgba(255, 255, 255, 0.82);
  margin: 0;
}

.report-hero__summary {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  display: flex;
  min-width: 168px;
  padding: 12px 18px;
  position: relative;
  z-index: 1;
}

.report-hero__summary i {
  font-size: 26px;
  margin-right: 13px;
}

.report-hero__summary strong,
.report-hero__summary span {
  display: block;
}

.report-hero__summary strong {
  font-size: 22px;
  line-height: 1.1;
}

.report-hero__summary span {
  color: rgba(255, 255, 255, 0.78);
  font-size: 11px;
  margin-top: 2px;
}

.report-list-card {
  border: 1px solid #e5ebf1;
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(41, 72, 105, 0.07);
  overflow: hidden;
}

.report-list-card > .card-body {
  padding: 26px;
}

.report-card__title {
  color: #2d4452;
  font-weight: 700;
}

.report-card__title small {
  color: #8295a2;
  font-size: 12px;
  font-weight: 400;
}

.report-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.report-actions .btn {
  margin: 0;
}

.report-icon-btn {
  align-items: center;
  background: #f4f9fb;
  border: 1px solid #dce8ed;
  border-radius: 7px;
  color: #317f91;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  min-width: 38px;
}

.report-search-btn,
.report-create-btn {
  align-items: center;
  background: #3193a7;
  border: 1px solid #3193a7;
  border-radius: 7px;
  color: #fff;
  display: inline-flex;
  gap: 6px;
  min-height: 38px;
}

.report-search-btn:hover,
.report-create-btn:hover {
  background: #287f91;
  border-color: #287f91;
  color: #fff;
}

.report-filter-panel {
  background: #f7fafc;
  border: 1px solid #e3eaf1;
  border-radius: 10px;
  clear: both;
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(190px, 1fr));
  margin-top: 20px;
  padding: 15px;
  width: 100%;
}

.report-filter-field label {
  color: #607683;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 7px;
  text-transform: uppercase;
}

.report-filter-field .form-control,
.report-filter-field::v-deep .form-control,
.report-filter-field::v-deep .mx-datepicker,
.report-filter-field::v-deep .mx-input {
  border-color: #d7e1e9;
  border-radius: 7px;
  min-height: 40px;
  width: 100%;
}

.report-table-cover {
  border: 1px solid #e2e9ef;
  border-radius: 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.report-table-cover table {
  margin: 0;
  min-width: 1120px;
  width: 100%;
}

.report-table-cover thead th {
  background: #edf6f8;
  color: #466071;
  font-weight: 600;
  white-space: nowrap;
}

.report-table-cover tbody tr:hover {
  background: #f5fbfb;
}

.report-row-actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  min-width: 126px;
}

.report-action {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 7px;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  min-width: 30px;
}

.report-action--send {
  background: #f1f5f7;
  border-color: #dde6ea;
  color: #5d7280;
}

.report-action--history {
  background: #eef5fb;
  border-color: #d6e5f1;
  color: #39728e;
}

.report-action--detail {
  background: #eaf7f5;
  border-color: #c4e6e0;
  color: #287a70;
}

.report-action--delete {
  background: #fff1f1;
  border-color: #f3d3d3;
  color: #c25353;
}

.report-action:hover {
  filter: brightness(0.96);
}

.report-contract-number {
  color: #315f78;
  font-weight: 700;
}

.report-client-name,
.report-client-address,
.report-period,
.report-revision-note {
  display: block;
}

.report-client-name {
  color: #344f60;
  margin-bottom: 4px;
}

.report-client-address,
.report-period {
  color: #7a8e9b;
  line-height: 1.45;
}

.report-contract-status {
  background: #eef5fb;
  border: 1px solid #d6e5f1;
  border-radius: 12px;
  color: #39728e;
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  margin-bottom: 7px;
  padding: 3px 8px;
  text-transform: capitalize;
}

.report-status {
  align-items: center;
  border-radius: 14px;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  gap: 6px;
  padding: 5px 9px;
  text-transform: capitalize;
}

.report-status__dot {
  background: currentColor;
  border-radius: 50%;
  height: 6px;
  width: 6px;
}

.report-status--draft {
  background: #fff7df;
  color: #aa7413;
}

.report-status--publish {
  background: #e8f7f1;
  color: #24785e;
}

.report-status--revision {
  background: #fff0ee;
  color: #b9574d;
}

.report-revision-note {
  color: #9b6d68;
  line-height: 1.4;
  margin-top: 6px;
}

.report-empty-state {
  align-items: center;
  color: #8295a2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 180px;
  padding: 28px;
  text-align: center;
}

.report-empty-state i {
  color: #7cbac1;
  font-size: 32px;
  margin-bottom: 10px;
}

.report-empty-state strong {
  color: #496271;
  margin-bottom: 4px;
}

.report-pagination {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  width: 100%;
}

.report-pagination::v-deep ul.pagination {
  display: flex;
  gap: 5px;
  margin: 0;
}

.report-pagination::v-deep .page-item a {
  align-items: center;
  background: #fff;
  border: 1px solid #d8e3eb;
  border-radius: 7px;
  color: #587083;
  display: flex;
  height: 34px;
  justify-content: center;
  min-width: 34px;
  padding: 0 9px;
}

.report-pagination::v-deep .page-item.active a {
  background: #3193a7;
  border-color: #3193a7;
  box-shadow: 0 5px 12px rgba(49, 147, 167, 0.25);
  color: #fff;
  font-weight: 700;
}

.report-pagination::v-deep .page-item a:hover {
  background: #eaf6f7;
  border-color: #72bdc5;
  color: #276d7b;
}

@media (max-width: 991px) {
  .report-filter-panel {
    grid-template-columns: repeat(2, minmax(190px, 1fr));
  }
}

@media (max-width: 767px) {
  .report-hero {
    align-items: stretch;
    flex-direction: column;
    min-height: 132px;
    padding: 22px 20px;
  }

  .report-hero__summary {
    margin-top: 18px;
    width: 100%;
  }

  .report-list-card > .card-body {
    padding: 16px;
  }

  .report-table-header {
    display: flex;
    flex-direction: column;
  }

  .report-actions {
    margin-top: 14px;
    width: 100%;
  }

  .report-actions .select,
  .report-actions .group {
    width: 100%;
  }

  .report-actions .select select,
  .report-actions .group input {
    width: 100%;
  }

  .report-filter-panel {
    grid-template-columns: 1fr;
    padding: 12px;
  }

  .report-pagination {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .report-pagination::v-deep ul.pagination {
    flex-wrap: wrap;
  }
}
</style>
